<template>
    <div class="row gy-2">
        <div class="col-12">
            <div class="row mb-4 g-2">
                <div class="col-12">
                    Monthly Deduction: <strong>₦{{ $filters.number_format(employeeUnion.evaluated_amount, 2) }} </strong>
                </div>
            </div>
            <div class="">
                <div class="mb-3 d-flex justify-content-between align-items-end">
                    <b-form-select style="max-width:80px;" class="form-select form-select-sm" v-model="itemsPerPage"
                                :options="pageOptions"></b-form-select>
                    <span class="mb-0">{{ paginationInfo }}</span>
                </div>
                <div class="table-responsive mb-0 loading-viewport">
                    <CommonSpinner v-if="isLoading" :box="true" />
                    <b-table striped hover ref="selectableTable" :items="pageData.data" :fields="columns"
                        responsive="sm" align="middle">
                        <template v-for="(column, colIndex) in columns.filter((i) => i.sortable)"
                            v-slot:[`head(${column.key})`]>
                            <div :key="colIndex" @click="setSortOrder(column)" class="
                                    d-flex align-items-center">
                                {{ column.label }} <span v-html="getSortingLabel(column.key)"></span>
                            </div>
                        </template>
                        <template v-for="(column, colIndex) in columns.filter((i) => i.auto)"
                            v-slot:[`cell(${column.key})`]="data">
                            <div @click="navigateTo(data.item.id)" :key="colIndex"
                                :style="{ 'width': `${column.width || '7'}rem` }"
                                class=" d-flex align-items-center">
                                <CommonTableTemplate :item="data.item" :column="column" />
                            </div>
                        </template>
                    </b-table>
                    <p v-if="!isLoading && !pageData.data.length" class="text-center mb-0 text-muted">No payments to
                        show</p>
                </div>
            </div>
            <div class="mt-4">
                <b-pagination v-model="currentPage" :limit="pageLimit" class="mb-0 pagination-rounded"
                    :total-rows="pageData.total" :per-page="itemsPerPage"></b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import { commonSortingMixin } from '@shared/mixins/commonSortingMixin';
import { commonPaginationMixin } from '@shared/mixins/commonPaginationMixin';

export default {
    name: "union-dues-payments",
    mixins: [
        commonSortingMixin,
        commonPaginationMixin
    ],
    props: {
        employeeUnion: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            isLoading: false,
            columns: [
                { key: "amount", auto: true, label: "Amount (₦)" },
                { key: "payroll_month", width: 5, auto: true, label: "Month" },
                { key: "payroll_year", width: 5, auto: true, label: "Year" },
            ],
            sortBy: {
                sort_column: "created_at",
                sort_direction: "desc"
            },
            pageData: {
                data: []
            },
            perPage: 10
        }
    },
    methods: {
        navigateTo(id) {

        },
        updateSearchQuery: _.debounce(function (string) {
            this.fetchItems()
        }, 2000),
        fetchItems(page, per_page = null) {
            let payload = {
                page: page || 1, per_page: per_page || this.itemsPerPage,
                ...this.sortBy, labour_union_id: this.employeeUnion.labour_union_id,
                employee_id: this.employeeUnion.employee_id
            }
            this.isLoading = true
            this.$http.get(`/union-dues-payments?${new URLSearchParams(payload).toString()}`)
                .then((response) => {
                    this.isLoading = false
                    if (response.data.success) {
                        this.pageData = response.data.data
                        this.initializeAll();
                    }
                })
        },
        initializeAll() {
        },
    },
    created() {
        this.fetchItems()
    },
}

</script>